<template>
  <div>
    <ml-table
      :pagination="false"
      :columns="columns"
      :dataSource="dataSource"
      bordered
      :loading="loading"
      :scroll="{ y: 300, x: 2700 }"
    >
      <template slot="batchCode" slot-scope="text, record">
        <div>
          <a-input
            v-if="record.editable && canAdd"
            :value="text"
            :placeholder="
              $t('common_please_input') + $t('page_material_warehousing_material_batch')
            "
            @change="(e) => handleChange(e.target.value, record, 'batchCode')"
          />
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
      <template slot="barCode" slot-scope="text, record">
        <div>
          <a-select
            style="width:100%"
            v-if="record.editable && canAdd"
            showSearch
            :placeholder="$t('please_select') + $t('page_material_warehousing_material_bar')"
            :dropdownMatchSelectWidth="false"
            :filterOption="false"
            :value="record.displayCode"
            @dropdownVisibleChange="(value) => getSpareMaterial(value, '')"
            @search="(value) => getSpareMaterial(true, value)"
            @change="(value) => changeMaterial(value, record)"
          >
            <template v-for="(item, index) in materialList">
              <a-select-option :key="index" :value="item.displayCode">
                {{ item.displayCode }}
              </a-select-option>
            </template>
          </a-select>
          <template v-else>
            {{ record.barCode }}
          </template>
        </div>
      </template>
      <template slot="totalNum" slot-scope="text, record">
        <div>
          <a-input-number
            :min="0"
            v-if="record.editable"
            :max="999999999"
            :value="text"
            @change="(e) => handleChange(e, record, 'totalNum')"
          />
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
      <template slot="stockInNum" slot-scope="text, record">
        <div>
          <a-input-number
            :min="0"
            v-if="record.editable"
            :max="999999999"
            :value="text"
            @change="(e) => handleChange(e, record, 'stockInNum')"
          />
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
      <template slot="price" slot-scope="text, record">
        <div>
          <a-input-number
            :min="0"
            v-if="record.editable && !tableDef.isPlan"
            :max="999999999"
            :value="text"
            @change="(e) => handleChange(e, record, 'price')"
          />
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
      <template slot="remark" slot-scope="text, record">
        <div>
          <a-input
            v-if="record.editable"
            :placeholder="$t('common_please_input') + $t('page_material_warehousing_remark')"
            :value="text"
            :maxLength="255"
            @change="(e) => handleChange(e.target.value, record, 'remark')"
          />
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
      <template slot="areaId" slot-scope="text, record">
        <div>
          {{ record.areaName }}
        </div>
      </template>
      <template slot="locationId" slot-scope="text, record">
        <div>
          <a-select
            v-if="record.editable && !tableDef.hasOutOrder"
            style="margin: -5px 0;width:100%;"
            :placeholder="$t('please_select') + $t('page_material_warehousing_location')"
            :value="text"
            showSearch
            :dropdownMatchSelectWidth="false"
            :filterOption="false"
            @dropdownVisibleChange="() => getLocationList(record)"
            @search="(value) => changeLocationList(value, record)"
            @change="(e) => handleChangeLocationId(e, record)"
          >
            <template v-for="(item, index) in locationList">
              <a-select-option :key="index" :value="item.id">
                {{ item.warehouseLocationName }}
              </a-select-option>
            </template>
          </a-select>
          <template v-else>
            {{ record.locationName }}
          </template>
        </div>
      </template>
      <template slot="supplierId" slot-scope="text, record">
        <div>
          <a-select
            v-if="record.editable"
            style="margin: -5px 0;width:100%;"
            :placeholder="$t('please_select') + $t('supplier')"
            :value="text"
            showSearch
            :dropdownMatchSelectWidth="false"
            :filterOption="false"
            @dropdownVisibleChange="() => getSupplierList(record)"
            @search="(value) => changeSupplierList(value, record)"
            @change="(e) => handleChange(e, record, 'supplierId')"
          >
            <a-select-option v-for="s in supplierList" :key="s.id" :value="s.id">
              {{ s.name }}
            </a-select-option>
          </a-select>
          <template v-else>
            {{ findSupplier(text) }}
          </template>
        </div>
      </template>
      <template slot="testResult" slot-scope="text, record">
        <div>
          <a-select
            v-if="record.editable && record.fileName"
            :placeholder="$t('please_select') + $t('page_material_warehousing_testResult')"
            style="margin: -5px 0;width:100%;"
            :value="text"
            @change="(e) => handleChange(e, record, 'testResult')"
          >
            <a-select-option :value="0">
              {{ $t('page_log_management_fail') }}
            </a-select-option>
            <a-select-option :value="1">
              {{ $t('page_log_management_success') }}
            </a-select-option>
          </a-select>
          <template v-else>
            {{
              text === null || text === undefined
                ? ''
                : text == 0
                ? $t('page_log_management_fail')
                : $t('page_log_management_success')
            }}
          </template>
        </div>
      </template>
      <template slot="fileName" slot-scope="text, record">
        <div>
          <a-upload
            :multiple="false"
            v-if="record.editable"
            :showUploadList="false"
            :beforeUpload="beforeUpload"
            :customRequest="(e) => handleChangefileName(e, record)"
          >
            <a-button> <a-icon type="upload" /> {{ $t('page_my_document_upload') }} </a-button>
          </a-upload>
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
      <template slot="key" slot-scope="key, record">
        <div class="editable-row-operations">
          <span v-if="record.editable">
            <a @click="() => saveTableEdit(key)">{{ $t('save') }}</a>
            <a-divider type="vertical" />
            <a @click="() => cancelTableEdit(key)">{{ $t('cancel') }}</a>
          </span>
          <span v-else>
            <a :disabled="disabled(record)" @click="() => edit(record)">{{ $t('edit') }}</a>
            <a-divider v-if="tableDef.isPlanAdd" type="vertical" />
            <a-popconfirm :title="$t('delete_tips')" @confirm="() => handleDelete(record)">
              <a v-if="tableDef.isPlanAdd" :disabled="disabled(record) || !canAdd"
                >{{ $t('delete') }}
              </a>
            </a-popconfirm>
          </span>
        </div>
      </template>
    </ml-table>
    <a-button
      type="primary"
      v-if="canAddMaterial"
      :disabled="editingKey !== '' || tableDef.canAddTwo"
      style="width:100%;margin-top: 8px;"
      @click="addMaterial()"
      >{{ $t('page_material_warehousing_add_material') }}</a-button
    >
  </div>
</template>
<script>
import table from './table.js'
import { PlanMaterialServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies'
import { MaterialServiceProxy } from '@/service-proxies/app-v2/material.service-proxies'

const pmsp = new PlanMaterialServiceProxy()
const msp = new MaterialServiceProxy()
export default {
  mixins: [table],
  props: {
    tableDef: {
      type: Object,
      default: () => ({})
    },
    areaId: {
      type: String,
      default: ''
    },
    inTypeCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      count: 1,
      loading: false,
      canAddMaterial: true,
      canAdd: true,
      canAddTwo: false,
      cacheData: [], // 物料列表缓存数据
      dataSource: [], // 物料列表
      areaList: [], // 库区列表
      locationList: [], // 库位列表
      supplierList: []
    }
  },
  watch: {
    tableDef: {
      handler() {
        this.dataSource = []
        this.cacheData = []
        this.canAddTwo = true
        if (this.tableDef.hasOutOrder || this.tableDef.selectPlan != '') {
          this.canAdd = false
          this.canAddMaterial = false
        } else {
          this.canAdd = true
          this.canAddMaterial = true
        }
        if (!this.tableDef.hasOutOrder) {
          if (this.tableDef.isPlan) {
            this.getMaterial()
          } else {
            this.getSpareMaterial()
          }
        }
      },
      deep: true,
      immediate: true
    },
    inTypeCode: {
      handler() {
        this.dataSource = []
        this.cacheData = []
        this.canAddMaterial = true
        this.canAdd = true
        this.getMaterial()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getSpareMaterial(bol, value) {
      if (!bol) {
        return
      }
      msp.getMaterialList(2, value, 4, '').then((res) => {
        this.materialList = res
      })
    },
    getMaterial() {
      // 如果入库类型为 物料入库及其他入库类型
      this.editingKey = ''
      const plan = this.tableDef.planList.find((res) => res.code === this.tableDef.selectPlan)
      if (plan) {
        pmsp.materialList('1', plan.id).then((res) => {
          this.dataSource = this.addKey(res)
          this.cacheData = this.addKey(res)
          this.isPlanAdd = false
          this.canAddMaterial = false
        })
      }
    },
    addValue(item, index, area, planMaterial) {
      const value = {
        key: index,
        id: item.id,
        materialId: item.id,
        planMaterialId: planMaterial ? planMaterial.id : '',
        barCode: item.barCode,
        materialTypeName: item.typeName,
        materialCode: item.code,
        materialName: item.name,
        batchCode: '',
        isMustCheck: item.isMustCheck,
        materialStandardModel: item.standardModel,
        materialStuff: item.stuff,
        materialUnit: item.unit,
        number: 0,
        totalNum: 0,
        stockInNum: 0,
        price: '',
        remark: '',
        areaId: this.areaId,
        areaName: area.name,
        locationId: '',
        locationName: '',
        testResult: null,
        contentType: '',
        supplierId: '',
        fileName: '',
        fileObjectKey: ''
      }
      return value
    },
    addKey(res) {
      const data = []
      if (res && res.length > 0) {
        const codes = []
        res.forEach((element) => {
          codes.push(element.materialCode)
        })
        msp.getMaterialByCode(codes).then((material) => {
          if (material && material.length > 0) {
            material.forEach((item, index) => {
              const area = this.areaList.find((res) => res.id === this.areaId)
              const planMaterial = res.find((res) => res.materialCode === item.code)
              const value = this.addValue(item, index, area, planMaterial)
              data.push(value)
            })
          }
        })
      }
      return data
    }
  }
}
</script>
<style scoped></style>
